import i18n from '../i18n'
const StateList = {
  loading(message) {
      return {
          'type': 'loading',
          'message': message || i18n.t('operationLoading'),
      }
  },
  error(message) {
      return {
          'type': 'error',
          'message': message || i18n.t('operationFailed'),
      }
  },
};

export default StateList;